import { z } from 'zod';
import { SalesOrderShortfallResolution } from '../../constants/sales-order-shortfall-resolution.js';
import { requiredUuidString } from '../zod-helpers/index.js';
export const shipShortfallChoiceInputSchema = z.object({
    salesOrderItemId: requiredUuidString('Sales order line is required.', 'Invalid sales order line selection.'),
    resolutionId: z.enum(SalesOrderShortfallResolution, 'Choose Void or Back order for each short line.'),
});
//# sourceMappingURL=ship-shortfall-choice-input.js.map